import './SamplingConfigsTable.css';

import React from 'react';
import B2BTableInMemory from '../../b2b-common/B2BTableInMemory';
import { toLocaleDateTime } from '../../b2b-common/helpers';
import { Delete } from '@mui/icons-material';
import ActionableIcon from '../../b2b-common/ActionableIcon';
import { useNavigate } from 'react-router-dom';
import { useLoginContext } from '../../../App';
import { useContentContext } from '../../layout/Layout';
import { deleteSamplingConfiguration } from '../../../services/b2b-iotsampling-apiService';
import { showNotification } from '../../b2b-common/Notification';
import useB2BTranslation from '../../b2b-common/hooks/useB2BTranslation';

const SamplingConfigsTable = ({ samplingConfigs, onDelete }) => {

    const { t } = useB2BTranslation('b2b-sampling');
    const { loginData } = useLoginContext();
    const { setNotification } = useContentContext();

    const navigate = useNavigate();

    if (!samplingConfigs || samplingConfigs.length === 0) {
        return null;
    }

    const handleDeleteSamplingConfig = async (areaIndicatorId) => {
        console.log('Delete sampling config:', areaIndicatorId);
        try {
            await deleteSamplingConfiguration(loginData.accessToken, loginData.loggedOrganizationUuid, areaIndicatorId);
            showNotification(setNotification, t('Sampling configuration for area indicator deleted successfully'), 'success', 3000);
            onDelete && onDelete(areaIndicatorId);
        } catch (error) {
            console.error('deleteSamplingConfiguration error:', error);
            showNotification(setNotification, t('Error deleting sampling configuration for area indicator'), 'error', 5000);
        }
    }

    const headers = [
        { label: t('Area indicator'), align: 'left' },
        { label: t('Enabled'), align: 'center' },
        { label: t('Frequency'), align: 'center' },
        { label: t('Last access'), align: 'center' },
        { label: '', align: 'center' },
    ];

    const rows = samplingConfigs.map((samplingConfig) => ({
        id: samplingConfig.areaIndicatorId,
        cells: [
            { content: samplingConfig.areaIndicatorDTO ? samplingConfig.areaIndicatorDTO.areaIndicatorName : t('NON EXISTENT'), align: 'left' },
            { content: samplingConfig.enabled ? t('Enabled') : t('Disabled'), align: 'center' },
            { content: `${samplingConfig.readFrequencyInMinutes} ${t('minutes')}`, align: 'center' },
            { content: toLocaleDateTime(samplingConfig.lastReadDate, true), align: 'center' },
            {
                content: <ActionableIcon
                    id={samplingConfig.areaIndicatorId} icon={Delete}
                    confirm={true} confirmDialog={t('Are you sure you want to delete this sampling configuration?')}
                    onConfirm={handleDeleteSamplingConfig}
                    tooltip={t('Delete sampling configuration')}
                />,
                align: 'center'
            },
        ],
    }));

    const handleSelectAreaIndicator = (rowSelected) => {
        const areaIndicator = samplingConfigs
            .find(samplingConfig => {
                return samplingConfig.areaIndicatorId === Number(rowSelected.id);
            }).areaIndicatorDTO;
        if (!areaIndicator) {
            console.error('Area indicator not found:', rowSelected.id);
            return
        } else {
            // console.log('Area indicator selected:', areaIndicator);
            const navigateTo = `/plans/plans-explorer/${areaIndicator.area.plan.planUUID}?selectedAreaId=${areaIndicator.area.areaId}&selectedAreaIndicatorId=${areaIndicator.areaIndicatorId}`;
            navigate(navigateTo);
        }
    }

    return (
        < B2BTableInMemory
            headers={headers} rows={rows}
            className={'sampling-configs-list-table'}
            numRows={5}
            stickyHeader={true}
            onRowClick={handleSelectAreaIndicator}
        />
    );
};

export default SamplingConfigsTable;